import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import { Field, Input } from '../../components/Field';

type BpValues = { bp_systolic: string; bp_diastolic: string; pulse: string };

/** Blood pressure (top/bottom) and pulse, laid out for one-handed entry. */
export function BloodPressureFields<T extends BpValues>({
  register,
  errors,
  label = 'Blood pressure'
}: {
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  label?: string;
}) {
  const reg = register as unknown as UseFormRegister<BpValues>;
  const err = errors as FieldErrors<BpValues>;
  return (
    <div>
      <span className="mb-1 block text-sm font-medium">{label}</span>
      <div className="grid grid-cols-[1fr_auto_1fr_1fr] items-end gap-2">
        <Input inputMode="numeric" aria-label={`${label} top number`} placeholder="120" {...reg('bp_systolic')} />
        <span className="pb-2.5 text-clinical-muted">/</span>
        <Input inputMode="numeric" aria-label={`${label} bottom number`} placeholder="80" {...reg('bp_diastolic')} />
        <Field label="Pulse">
          <Input inputMode="numeric" placeholder="72" {...reg('pulse')} />
        </Field>
      </div>
      {err.bp_systolic?.message || err.bp_diastolic?.message || err.pulse?.message ? (
        <p className="mt-1 text-xs text-clinical-danger">{err.bp_systolic?.message ?? err.bp_diastolic?.message ?? err.pulse?.message}</p>
      ) : null}
    </div>
  );
}
